/**
 * Pix BR Code (EMV static) builder — gera o "copia e cola" Pix e
 * a string usada no QR Code, a partir da chave + metadados.
 * Referência: Manual do BR Code — Banco Central.
 */

function crc16(payload) {
  let crc = 0xffff;
  for (let i = 0; i < payload.length; i++) {
    crc ^= payload.charCodeAt(i) << 8;
    for (let j = 0; j < 8; j++) {
      crc = crc & 0x8000 ? (crc << 1) ^ 0x1021 : crc << 1;
      crc &= 0xffff;
    }
  }
  return crc.toString(16).toUpperCase().padStart(4, "0");
}

function field(id, value) {
  const v = String(value ?? "");
  return id + String(v.length).padStart(2, "0") + v;
}

/** Remove accents + uppercase + strip non-standard chars — required by EMV. */
function sanitize(text, max) {
  return text
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-zA-Z0-9 ]/g, "")
    .toUpperCase()
    .trim()
    .slice(0, max);
}

/**
 * Build the Pix "Copia e Cola" (BR Code) string.
 * @param {object} opts
 * @param {string} opts.key - Pix key (CNPJ digits only, e-mail, EVP/uuid, phone, etc.)
 * @param {string} opts.name - Recipient name (up to 25 chars, ascii).
 * @param {string} opts.city - Recipient city (up to 15 chars, ascii).
 * @param {string} [opts.txid="***"] - Transaction identifier.
 * @param {number} [opts.amount] - Fixed amount in BRL (optional, omit for dynamic).
 * @returns {string} BR Code string (also used for the QR image).
 */
export function buildPixBRCode({ key, name, city, txid = "***", amount }) {
  const merchantAccount = field("00", "BR.GOV.BCB.PIX") + field("01", key);
  let payload =
    field("00", "01") +
    field("01", "12") + // static / reusable
    field("26", merchantAccount) +
    field("52", "0000") +
    field("53", "986") +
    (typeof amount === "number" && amount > 0
      ? field("54", amount.toFixed(2))
      : "") +
    field("58", "BR") +
    field("59", sanitize(name, 25)) +
    field("60", sanitize(city, 15)) +
    field("62", field("05", txid));
  payload += "6304";
  return payload + crc16(payload);
}
